<dojo-button
  [matMenuTriggerFor]="state.isSmall ? null : filtersMenu"
  #menuTrigger="matMenuTrigger"
  [size]="'m'"
  [fill]="'outline'"
  [customColor]="isSelected() ? 'sky' : undefined"
  (click)="onButtonClick()"
>
  <dojo-icon [icon]="'bars-filter'" class="mr-2" />
  <span class="font-medium">{{ buttonLabel() }}</span>
  @if (isSelected()) {
    <span class="count-badge ml-2">{{ totalCount() }}</span>
  }
</dojo-button>

<mat-menu #filtersMenu="matMenu" class="custom-mat-menu filters-panel-menu no-width-constraints">
  <div class="filters-panel-desktop" (click)="$event.stopPropagation()">
    <div class="flex min-h-0 flex-1">
      <div class="filters-panel-sidebar">
        @for (section of sections(); track section.name()) {
          <button
            type="button"
            class="filter-tab"
            [ngClass]="{
              'bg-sky-50 text-sky-600': selectedSectionName() === section.name()
            }"
            (click)="selectSection(section.name())"
          >
            <span>{{ section.label() }}</span>
            @if (section.count() > 0) {
              <span
                class="tab-count"
                [ngClass]="
                  selectedSectionName() === section.name() ? 'text-neutral-0 bg-sky-500' : 'bg-sky-100 text-sky-600'
                "
              >
                {{ section.count() }}
              </span>
            }
          </button>
        }
      </div>

      <div class="filters-panel-content">
        @if (selectedSection(); as section) {
          <div class="text-md px-4 font-semibold">{{ section.label() }}</div>
          <ng-container *ngTemplateOutlet="section.templateRef" />
        }
      </div>
    </div>

    <div class="filters-panel-footer">
      <button
        type="button"
        class="link-component"
        [class.!text-disabled]="!isSelected()"
        [disabled]="!isSelected()"
        (click)="onClearAll()"
      >
        {{ 'examdojo.clear_all' | transloco }}
      </button>
      <dojo-button [fill]="'outline'" [size]="'s'" (click)="closeMenu()" [customColor]="'sky'">
        {{ 'examdojo.close' | transloco }}
      </dojo-button>
    </div>
  </div>
</mat-menu>
